import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@bibliocommons/base-buttons';

export default function FulfilmentButton({ modalActions, modalKey }) {
  function handleOpen() {
    modalActions.openModal(modalKey, { accountRequired: true });
  }

  return (
    <Button className="cp-fulfilment-button" handleClick={handleOpen} dataKey="fulfilment-button">
      <FormattedMessage id="access_this_item" />
    </Button>
  );
}

FulfilmentButton.propTypes = {
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalKey: PropTypes.string.isRequired
};
